import React, { useState } from 'react';
import { TiDeleteOutline } from 'react-icons/ti';
import ConfirmModal from '../../../views/PropertiesPage/ConfirmModal';
import { useFormikContext } from 'formik';

export default function ClearButton({ type }) {
  const [clearPrompt, setClearPrompt] = useState(false);

  //remove reset button until further debugging
  // const [resetPrompt, setResetPrompt] = useState(false);

  const { setValues, values, submitForm } = useFormikContext();

  const onClear = async () => {
    if (!values) return;

    const newValues = Object.keys(values).reduce((acc, key) => {
      acc[key] = null;
      return acc;
    }, {});

    switch (type) {
      case 'purchaseWorksheet':
        newValues.purchaseWorksheetSubmitted = false;
        break;
      case 'rehabWorksheetPt1':
        newValues.rehabDetailsSubmitted = false;
      case 'rehabWorksheet':
        newValues.rehabWorksheetSubmitted = false;
        newValues.refinancingWorksheetSubmitted = false;
        break;
      case 'refinancing':
        newValues.refinancingWorksheetSubmitted = false;
        break;
    }

    setValues(newValues);
    try {
      await submitForm();
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="w-full flex justify-center items-center mt-10">
      {/* <button
        className="mx-auto px-2 py-1 rounded text-base bg-neutral-400 shadow-md text-white font-medium flex items-center justify-between gap-[6px] hover:bg-warning focus:bg-warning hover:text-white focus:text-white focus:ring-2 focus:ring-offset-2 focus:ring-warning focus:outline-none"
        type="button"
        onClick={() => setResetPrompt(true)}
      >
        Reset Form <IoIosRefresh className="inline-block text-md" />
      </button> */}
      <button
        className="mx-auto px-2 py-1 rounded text-base bg-neutral-400 shadow-md text-white font-medium flex items-center justify-between gap-[6px] hover:bg-warning focus:bg-warning hover:text-white focus:text-white focus:ring-2 focus:ring-offset-2 focus:ring-warning focus:outline-none"
        type="button"
        onClick={() => setClearPrompt(true)}
      >
        Clear Form <TiDeleteOutline className="inline-block text-lg" />
      </button>
      <ConfirmModal
        onConfirm={onClear}
        showPrompt={clearPrompt}
        setShowPrompt={setClearPrompt}
        title={'Clear Form Data'}
        description={
          'This will clear all data for the current form (including saved data). This action cannot be undone.'
        }
        cancelText={'Cancel'}
        confirmText={'Clear Form'}
      />
      {/* <ConfirmModal
        onConfirm={resetForm}
        showPrompt={resetPrompt}
        setShowPrompt={setResetPrompt}
        title={'Reset Form Data'}
        description={
          'This will remove any unsubmitted changes to the current form.'
        }
        cancelText={'Cancel'}
        confirmText={'Reset Form'}
      /> */}
    </div>
  );
}
